import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Checkout } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class CheckoutService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  // todo basic default schema to fetch
  public async getCheckout(id, schema: { id: null; name: null }): Promise<Checkout> {
    return new Checkout(await this.core.services.checkout.getById(id, schema))
  }

  async getCheckouts(
    parameters: any = {
      page: 1,
      sort: 'id',
      direction: 'asc',
    },
    schema: any = { id: null, name: null, enabled: null }
  ): Promise<{
    items: Checkout[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.checkout.getList(parameters, schema)
  }

  createCheckout(checkout: Partial<Checkout>, schema: any): Promise<Checkout> {
    return this.core.services.checkout.create(checkout, schema)
  }

  updateCheckout(checkout: Partial<Checkout>, schema: any): Promise<Checkout> {
    return this.core.services.checkout.update(checkout, schema)
  }

  deleteCheckout(checkout: Checkout | Partial<Checkout>): Promise<any> {
    return this.core.services.checkout.delete(checkout)
  }

  // async getEventTypes(parameters: any = {}, schema: any = { id: null, name: null }): Promise<{
  async getEventTypes(
    parameters: any = {},
    schema: any = {}
  ): Promise<{
    items: [{ id: null }]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.checkout.getEventTypes()
  }

  doesUserHaveAllCheckouts(allCheckouts, userCheckouts?) {
    return allCheckouts?.length
      ? allCheckouts.every(checkout => {
          return this.core.services.user.user?.checkouts.some(ch => ch.id === checkout.id)
        })
      : []
  }

  setNextBillNumber(checkout: Checkout | Partial<Checkout>, schema: any = { id: null }): Promise<Checkout> {
    return this.core.services.checkout.setNextBillNumber(checkout, schema)
  }

  setNextReservationNumber(checkout: Checkout | Partial<Checkout>, schema: any = { id: null }): Promise<Checkout> {
    return this.core.services.checkout.setNextReservationNumber(checkout, schema)
  }
}
